<template>
    <tr style="border-bottom: 0 !important;">
        <v-lazy
            v-for="(header, index) in headers"
            :key="index"
            tag="td"
            :class="[
                'group-header-col',
                'text-' + header.align,
                'col-' + header.value,
                isTdZeroPadding(header.value) ? 'px-0' : '',
                isExpanded ? 'col-is-expanded' : ''
            ]"
            :style="[
                headerHasBorder(header) ? { 'border-bottom': '1px solid rgba(0, 0, 0, 0.12) !important'} : { 'border': '0' },
                header.value === 'flextime_credit' ? { 'border-left': '1px solid rgba(0, 0, 0, 0.12) !important' } : ''
            ]"
        >
            <div
                :class="header.class"
                class="main--text body-2"
            >
                <span v-if="header.value === 'avatar'">
                    <v-row
                        no-gutters
                        class="fill-height"
                    >
                        <v-col style="min-width: 307px; width: 307px; max-width: 307px;">
                            <v-row
                                no-gutters
                                align="center"
                                class="fill-height"
                                style="flex-wrap: nowrap"
                            >
                                <v-btn
                                    icon
                                    @click="expand(item, !isExpanded)"
                                >
                                    <v-icon>
                                        {{ isExpanded ? "mdi-menu-down" : "mdi-menu-right" }}
                                    </v-icon>
                                </v-btn>

                                <span style="cursor: pointer;" @click="onAccountAvatarClick(item)">
                                    <AccountAvatar
                                        v-show="normalizedChild && normalizedChild.initials"
                                        size="31"
                                        tile
                                        :color="normalizedChild.color"
                                        :text-color="normalizedChild.text_color"
                                        :avatar="normalizedChild.avatar"
                                        :initials="normalizedChild.initials"
                                        text-class="body-2 font-weight-medium"
                                    />
                                </span>
                                <span
                                    class="body-2 ml-4 mr-2 text-truncate grey--text text--darken-4"
                                    style="cursor: pointer;"
                                    @click="onItemTitleClick(item)"
                                >
                                    {{ normalizedChild.name }}
                                </span>
                            </v-row>
                        </v-col>
                    </v-row>
                </span>
                <span v-else-if="header.value === 'flextime_status'">
                    <v-row
                        no-gutters
                        align="center"
                        class="fill-height flex-nowrap"
                    >
                        <v-spacer/>
                        <template v-if="canEditCompanyOrIsEditablePeriod">
                            <template v-if="!item.flextime_status || item.flextime_status === FlextimeModule.FLEXTIME_STATUS.PENDING">
                                <div class="d-flex align-center">
                                    <icon-button
                                        color="tretiary darken-1"
                                        @click="selectFlextimeDecisionOption(FlextimeModule.FLEXTIME_STATUS.ACCEPTED)"
                                    >
                                        mdi-check
                                    </icon-button>
                                    <icon-button
                                        color="error"
                                        @click="selectFlextimeDecisionOption(FlextimeModule.FLEXTIME_STATUS.DECLINED)"
                                    >
                                        mdi-close
                                    </icon-button>
                                </div>
                            </template>
                            <template v-else>
                                <action-menu
                                    :items="flextimeDecisionActionItems"
                                    @action="flextimeDecisionActionItems[$event].action()"
                                >
                                    <template v-slot:activator="{ on, isOpen }">
                                        <v-btn
                                            class="font-weight-regular text-capitalize"
                                            text
                                            v-on="on"
                                        >
                                            <v-icon
                                                class="mr-1"
                                                :color="selectedFlextimeDecisionIconColor"
                                            >
                                                {{ selectedFlextimeDecisionButtonIcon }}
                                            </v-icon>
                                            <div class="body-2">
                                                {{ selectedFlextimeDecisionText }}
                                            </div>
                                            <v-icon color="g4">
                                                {{ isOpen ? 'mdi-menu-up' : 'mdi-menu-down' }}
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                </action-menu>
                                <v-tooltip bottom :disabled="!item.flextime_comment">
                                    <template v-slot:activator="{ on }">
                                        <icon-button
                                            :on="on"
                                            :icon="item.flextime_comment ? 'CommentFilled' : 'MessageSquare'"
                                            @click="isChangeFlextimeCommentModalVisible = true"
                                        />
                                    </template>
                                    {{ item.flextime_comment }}
                                </v-tooltip>
                            </template>
                        </template>
                        <template v-else>
                            <div class="px-3 d-flex align-center">
                                <v-icon
                                    class="mr-1"
                                    :color="selectedFlextimeDecisionIconColor"
                                >
                                    {{ selectedFlextimeDecisionButtonIcon }}
                                </v-icon>
                                <div>
                                    {{ selectedFlextimeDecisionText }}
                                </div>
                            </div>
                        </template>
                    </v-row>
                </span>
                <span v-else-if="header.value === 'flextime_credit'">
                    <v-row
                        no-gutters
                        align="center"
                        class="fill-height flex-nowrap"
                        :class="item.flextime_credit < 0 ? 'error--text' : 'tretiary--text text--darken-1'"
                    >
                        <div class="font-weight-medium tabular-nums">
                            {{ formatFlextimeDuration(item.flextime_credit) }}
                        </div>
                        <div class="ml-auto">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <icon-button
                                        :on="on"
                                        icon="CalendarClock"
                                        @click="isFlextimeHistoryModalVisible = true"
                                    />
                                </template>
                                {{ $t('View history') }}
                            </v-tooltip>
                        </div>
                    </v-row>
                </span>
                <span v-else-if="header.value === 'tasks_count'">
                    <div class="cursor-pointer" @click="onItemTitleClick(item)">
                        {{ item.tasks_count }}
                    </div>
                </span>
                <span v-else-if="header.value === 'flextime_period'">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <div v-on="on">
                                {{ getFlextimePeriodShort() }}
                            </div>
                        </template>
                        <div
                            v-if="item.flextime_date_from && item.flextime_date_until"
                            class="tabular-nums"
                        >
                            {{ formatDate(parseSysDate(item.flextime_date_from)) }} - {{ formatDate(parseSysDate(item.flextime_date_until)) }}
                        </div>
                    </v-tooltip>
                </span>
                <span v-else-if="header.value === 'flextime_office_time'">
                    <v-row
                        no-gutters
                        align="center"
                        class="fill-height tabular-nums"
                        justify="end"
                    >
                        <div>{{ item.flextime_office_time ? formatTimeDuration(item.flextime_office_time) : '' }}</div>
                    </v-row>
                </span>
                <span v-else-if="header.value === 'flextime_office_percent'">
                    <v-row
                        no-gutters
                        align="center"
                        class="fill-height tabular-nums"
                        justify="end"
                    >
                        <div>{{ item.flextime_office_percent ? formatPercent(item.flextime_office_percent) : '' }}</div>
                    </v-row>
                </span>
                <span v-else-if="header.value === 'flextime_office_agreed_time'">
                    <v-row
                        no-gutters
                        align="center"
                        class="fill-height tabular-nums"
                        justify="end"
                    >
                        <div>{{ item.flextime_office_agreed_time ? formatTimeDuration(item.flextime_office_agreed_time) : '' }}</div>
                    </v-row>
                </span>
                <span v-else-if="header.value === 'flextime_expected'">
                    <v-row
                        no-gutters
                        align="center"
                        class="fill-height tabular-nums"
                        justify="end"
                    >
                        <div>{{ formatTimeDuration(item.flextime_expected) }}</div>
                    </v-row>
                </span>
                <span v-else-if="header.value === 'flextime_balance'">
                    <v-row
                        no-gutters
                        align="center"
                        class="fill-height flex-nowrap"
                    >
                        <v-spacer/>
                        <v-tooltip
                            v-if="canEditCompanyOrIsEditablePeriod"
                            bottom
                            :disabled="!item.flextime_id"
                        >
                            <template #activator="{ on }">
                                <div v-show="canEditCompanyOrIsEditablePeriod">
                                    <v-btn
                                        text
                                        class="font-weight-regular tabular-nums px-2"
                                        :class="item.flextime_balance < 0 ? 'error--text' : 'tretiary--text text--darken-1'"
                                        v-on="on"
                                        @click="isChangeFlextimeBalanceModalVisible = true"
                                    >
                                        {{ formatFlextimeDuration(item.flextime_balance) }}
                                        <icon
                                            v-if="[FlextimeModule.FLEXTIME_STATUS.DECLINED, FlextimeModule.FLEXTIME_STATUS.ACCEPTED].includes(item.flextime_status)"
                                            class="ml-1"
                                            color="g4"
                                            size="16"
                                            icon="Lock"
                                        />
                                        <icon
                                            v-else
                                            class="ml-1"
                                            :color="item.flextime_id ? 'tretiary' : 'g4'"
                                            size="16"
                                            icon="Pen"
                                        />
                                    </v-btn>
                                </div>
                            </template>
                            {{ $t('Time entry has been confirmed or duration has been changed and duration will not dynamically update') }}.
                        </v-tooltip>
                        <v-tooltip
                            v-else
                            bottom
                            :disabled="!item.flextime_id"
                        >
                            <template #activator="{ on }">
                                <div v-show="!canEditCompanyOrIsEditablePeriod">
                                    <div
                                        class="font-weight-regular px-2 tabular-nums d-flex align-center"
                                        :class="item.flextime_balance < 0 ? 'error--text' : 'tretiary--text text--darken-1'"
                                        v-on="on"
                                    >
                                        {{ formatFlextimeDuration(item.flextime_balance) }}
                                        <icon
                                            v-if="[FlextimeModule.FLEXTIME_STATUS.DECLINED, FlextimeModule.FLEXTIME_STATUS.ACCEPTED].includes(item.flextime_status)"
                                            class="ml-1"
                                            color="g4"
                                            size="16"
                                            icon="Lock"
                                        />
                                        <icon
                                            v-else-if="item.flextime_id"
                                            class="ml-1"
                                            color="tretiary"
                                            size="16"
                                            icon="Pen"
                                        />
                                    </div>
                                </div>
                            </template>
                            {{ $t('Time entry has been confirmed or duration has been changed and duration will not dynamically update') }}.
                        </v-tooltip>
                        <v-tooltip bottom color="white" content-class="elevation-3 main--text max-width-tooltip">
                            <template v-slot:activator="{ on }">
                                <div
                                    style="margin-left: 2px"
                                    class="d-flex"
                                    v-on="on"
                                >
                                    <icon
                                        icon="Info"
                                        size="18"
                                    />
                                </div>
                            </template>
                            <VacationDurationList :vacation-duration="item.flextime_calculations"/>
                        </v-tooltip>
                    </v-row>
                </span>
                <span v-else-if="header.value === 'progress'">
                    <v-row
                        no-gutters
                        align="center"
                        class="fill-height"
                    >
                        <div
                            class="progress-wrapper"
                            style="width: 100%; min-width: 300px;"
                        >
                            <v-progress-linear
                                class="report-progress-colors"
                                :buffer-value="primaryValue"
                                :value="secondaryValue"
                                color="primary"
                                height="20"
                                reactive
                            />
                        </div>
                    </v-row>
                </span>
                <v-row
                    v-else-if="header.value === 'extra'"
                    no-gutters
                    align="center"
                    justify="end"
                    class="fill-height"
                >
                    <span
                        v-if="item.extra"
                        class="body-2 grey--text text--darken-4 tabular-nums"
                    >
                        {{ formatTimeDuration(item.extra) }}
                    </span>
                    <div
                        v-else
                        class="progress-wrapper"
                        style="height: 8px; width: 27px"
                    ></div>
                </v-row>
                <v-row
                    v-else-if="header.value === 'total'"
                    no-gutters
                    align="center"
                    justify="end"
                    class="fill-height"
                >
                    <span
                        v-if="item.total"
                        class="body-2 grey--text text--darken-4 tabular-nums"
                    >
                        {{ formatTimeDuration(item.total) }}
                    </span>
                    <div
                        v-else
                        class="progress-wrapper"
                        style="height: 8px; width: 27px"
                    ></div>
                </v-row>
                <v-row
                    v-else
                    :justify="header.justify"
                    no-gutters
                >
                    <div v-if="item[header.value]"
                         :class="header.type === 'time' ? 'tabular-nums' : ''">
                        {{ formatByHeader(item[header.value], header) }}
                    </div>
                    <div v-else
                         class="progress-wrapper "
                         style="height: 8px; width: 27px"></div>
                </v-row>
            </div>
        </v-lazy>
        <FlextimeHistoryModal
            v-if="isFlextimeHistoryModalVisible"
            :person-id="item.group_id"
            :company-id="companyId"
            :person-name="item.name"
            @close="isFlextimeHistoryModalVisible = false"
        />
        <ReportChangeFlextimeBalanceModal
            v-if="isChangeFlextimeBalanceModalVisible"
            :balance="item.flextime_balance"
            :flextime-id="item.flextime_id"
            @close="isChangeFlextimeBalanceModalVisible = false"
            @update-balance="updateBalance"
            @clear="deleteFlextime(item.flextime_id)"
        />
        <ReportChangeFlextimeCommentModal
            v-if="isChangeFlextimeCommentModalVisible"
            :comment="item.flextime_comment"
            :flextime-id="item.flextime_id"
            @close="isChangeFlextimeCommentModalVisible = false"
            @update-comment="updateComment"
        />
    </tr>
</template>

<script>
import {format_time_from_seconds} from "../../helpers/formatting";
import AccountAvatar from "../../components/AccountAvatar";
import BookmarkModule from "../../store/modules/bookmark";
import {$t} from "../../i18n";
import ReportDefaultColumns from "./ReportDefaultColumns";
import {
    formatDateShort,
    parseSysDate,
    formatDateCustom,
    calcDateEquals,
    formatWeekdayShort,
    formatTimeDuration,
    formatFlextimeDuration,
    formatDate,
    formatByHeader,
    CustomFormats,
    formatPercent
} from '../../plugins/formatting';
import router from "@/router";
import {computed, reactive, ref} from "@vue/composition-api";
import Loader from "@/utility/loader";
import errorDialog from "@/views/ErrorDialog/errorDialog";
import AppModule from "../../store/modules/app";
import ReportModule from '../../store/modules/report'
import RightsModule from "@/composables/use-rights";
import ApiFlextime from "@/api/report/flextime";

import ReportChangeFlextimeBalanceModal from "@/views/Report/ReportChangeFlextimeBalanceModal";
import ReportChangeFlextimeCommentModal from "@/views/Report/ReportChangeFlextimeCommentModal";
import FlextimeHistoryModal from "@/components/Flextime/FlextimeHistoryModal";
import FlextimeModule from "@/modules/flextime/flextime";
import VacationDurationList from "@/components/Flextime/VacationDurationList";

export default {
    name: "ReportSummaryRow",
    components: {
        AccountAvatar,
        ReportChangeFlextimeBalanceModal,
        ReportChangeFlextimeCommentModal,
        FlextimeHistoryModal,
        VacationDurationList
    },
    props: {
        item: {
            type: Object,
            required: true
        },
        expand: {
            type: Function,
            default: () => false
        },
        isExpanded: {
            type: Boolean
        },
        headers: {
            type: Array,
            default: () => []
        },
        primaryValue: {
            type: Number,
            default: 0
            // percentageFromMax(item)
        },
        secondaryValue: {
            type: Number,
            default: 0
            // extraPercentage(item)
        },
        grouping: {
            type: String,
            required: true
        },
        urlAdapter: {
            type: Object,
            default: () => ({}),
        },
        view: {
            type: String,
            default: null
        }
    },
    setup(props) {
        const isChangeFlextimeBalanceModalVisible = ref(false);
        const isChangeFlextimeCommentModalVisible = ref(false);
        const isFlextimeHistoryModalVisible = ref(false);
        const {navigate_report_default_route} = BookmarkModule();
        const rightsModule = RightsModule()
        const {projects_map} = ReportModule();

        const loader = reactive(new Loader());

        const appModule = AppModule();
        const {default_task_columns} = ReportDefaultColumns();
        const normalizedChild = computed(() => {
            if (!props.item) return "false";
            let current_grouping = String(props.grouping).split(";");
            let primary_grouping = current_grouping[0];
            if (primary_grouping === "client") {
                if (props.item.client) {
                    props.item.client.initials = props.item.client.client_initials;
                    return props.item.client;
                }
                return {
                    initials: "#",
                    color: "color-36",
                    name: props.item.group_id
                };
            } else if (primary_grouping === "project") {
                if (projects_map.value[String(props.item.group_id)]) {
                    const project = projects_map.value[String(props.item.group_id)]
                    if (project)
                        return {name: project.name, initials: project.initials, color: project.color}
                }
                return {color: "grey lighten-2", text_color: "neutral_n300", name: $t("(Without project)"), initials: '-'}

            } else if (primary_grouping === "date") {
                let name = "";
                if (props.item.group_id && typeof props.item.group_id == "string" && props.item.group_id.startsWith("W")) {
                    const year_month_week = props.item.group_id.substr(1);
                    const [year, week] = year_month_week.split("_");
                    const is_this_year = calcDateEquals(new Date(), new Date(year, 0, 1), "year");
                    const year_str = is_this_year ? "" : ", " + year;
                    name = $t("Week") + " " + week + year_str;
                } else if (props.item.group_id.length === 10) {
                    name = formatDateShort(props.item.group_id) + " " + formatWeekdayShort(parseSysDate(props.item.group_id));
                } else if (props.item.group_id.length === 7) {
                    name = formatDateCustom(parseSysDate(props.item.group_id + "-01"), CustomFormats.short_month_name_with_full_year);
                }
                return {name};
            } else {
                return {color: "grey lighten-2", text_color: "neutral_n300", ...props.item};
            }
        });
        const onItemTitleClick = item => {
            const current_grouping = String(props.grouping).split(";");
            const primary_grouping = current_grouping[0];
            if (primary_grouping === "client") {
                navigate_report_default_route({
                    view: "detailed",
                    dates_list: props.urlAdapter.getUrlParameter("dates_list"),
                    client_id_list: [Number(item.group_id.split("_")[1])],
                    columns: default_task_columns,
                    groupBy: props.grouping,
                });
            } else if (primary_grouping === "assignee") {
                navigate_report_default_route({
                    view: "detailed",
                    dates_list: props.urlAdapter.getUrlParameter("dates_list"),
                    person_id_list: [Number(item.group_id)],
                    columns: default_task_columns,
                    groupBy: props.grouping,
                });
            }
        };

        const flextimeDecisionActionItems = computed(() => {
            let output = []

            if (props.item.flextime_status === FlextimeModule.FLEXTIME_STATUS.ACCEPTED) {
                output.push({
                    text: $t('Decline'),
                    action: () => selectFlextimeDecisionOption(FlextimeModule.FLEXTIME_STATUS.DECLINED)
                })
            } else if (props.item.flextime_status === FlextimeModule.FLEXTIME_STATUS.DECLINED) {
                output.push({
                    text: $t('Accept'),
                    action: () => selectFlextimeDecisionOption(FlextimeModule.FLEXTIME_STATUS.ACCEPTED)
                })
            }

            output.push({
                text: $t('Cancel decision'),
                action: () => deleteFlextime()
            })

            return output
        })

        const deleteFlextime = async () => {
            await loader.withLoader(async () => {
                try {
                    await ApiFlextime.deleteFlextime(props.item.flextime_id)
                    await props.urlAdapter.updateUrlParameters();
                } catch (e) {
                    errorDialog.showError(e)
                }
            })
        }

        const selectFlextimeDecisionOption = async (option) => {
            await loader.withLoader(async () => {
                try {
                    await ApiFlextime.saveFlextime(
                        props.item.flextime_id,
                        option,
                        props.item.flextime_date_from,
                        props.item.flextime_date_until,
                        props.item.flextime_type,
                        props.item.flextime_week,
                        props.item.group_id,
                        props.item.account_id,
                        props.item.flextime_comment,
                        props.item.flextime_balance
                    )
                    await props.urlAdapter.updateUrlParameters();
                } catch (e) {
                    errorDialog.showError(e)
                }
            })
        }

        const selectedFlextimeDecisionButtonIcon = computed(() => {
            if (props.item.flextime_status === FlextimeModule.FLEXTIME_STATUS.ACCEPTED) {
                return 'mdi-checkbox-marked-circle-outline'
            } else if (props.item.flextime_status === FlextimeModule.FLEXTIME_STATUS.DECLINED) {
                return 'mdi-close-circle-outline'
            }
        })

        const selectedFlextimeDecisionText = computed(() => {
            if (props.item.flextime_status === FlextimeModule.FLEXTIME_STATUS.ACCEPTED) {
                return $t('Accepted')
            } else if (props.item.flextime_status === FlextimeModule.FLEXTIME_STATUS.DECLINED) {
                return $t('Declined')
            }
        })

        const selectedFlextimeDecisionIconColor = computed(() => {
            if (props.item.flextime_status === FlextimeModule.FLEXTIME_STATUS.ACCEPTED) {
                return 'tretiary darken-1'
            } else if (props.item.flextime_status === FlextimeModule.FLEXTIME_STATUS.DECLINED) {
                return 'error'
            }
        })

        const isTdZeroPadding = (headerName) => {
            let zeroPaddingHeaders = [
                //'flextime_balance',
                //'flextime_status'
            ]

            return zeroPaddingHeaders.includes(headerName)
        }

        const updateBalance = async (balance) => {
            await loader.withLoader(async () => {
                try {
                    await ApiFlextime.saveFlextime(
                        props.item.flextime_id,
                        props.item.flextime_status ? props.item.flextime_status : FlextimeModule.FLEXTIME_STATUS.PENDING,
                        props.item.flextime_date_from,
                        props.item.flextime_date_until,
                        props.item.flextime_type,
                        props.item.flextime_week,
                        props.item.group_id,
                        props.item.account_id,
                        props.item.flextime_comment,
                        balance
                    )
                    await props.urlAdapter.updateUrlParameters();
                } catch (e) {
                    errorDialog.showError(e)
                }
            })
        }

        const updateComment = async (comment) => {
            await loader.withLoader(async () => {
                try {
                    await ApiFlextime.saveFlextime(
                        props.item.flextime_id,
                        props.item.flextime_status ? props.item.flextime_status : FlextimeModule.FLEXTIME_STATUS.PENDING,
                        props.item.flextime_date_from,
                        props.item.flextime_date_until,
                        props.item.flextime_type,
                        props.item.flextime_week,
                        props.item.group_id,
                        props.item.account_id,
                        comment,
                        props.item.flextime_balance
                    )
                    await props.urlAdapter.updateUrlParameters();
                } catch (e) {
                    errorDialog.showError(e)
                }
            })
        }

        const headerHasBorder = (header) => {
            if (header.group !== 'flextime') {
                return false
            }

            const borderHeaders = [
                'flextime_balance',
                'total',
                'flextime_expected',
                'tasks_count',
                'flextime_period',
                'flextime_status',
                'flextime_credit',
                'flextime_office_time',
                'flextime_office_percent',
                'flextime_office_agreed_time'
            ]

            return borderHeaders.includes(header.value)
        }

        const companyId = computed(() => {
            let account_id = props.urlAdapter.getUrlParameter('account_id');

            if (Array.isArray(account_id)) {
                account_id = account_id[0]
            }

            return account_id
        })

        const canEditCompanyOrIsEditablePeriod = computed(() => {
            const accountId = props.urlAdapter.getUrlParameter('account_id');
            if (!accountId) {
                return false
            }

            if (!rightsModule.can_edit_account(accountId)) {
                return false
            }

            const datesList = props.urlAdapter.getUrlParameter('dates_list');
            if (!datesList) {
                return false
            }

            const startDateString = datesList[0]
            if (!startDateString) {
                return false
            }

            const now = new Date();
            const endDate = parseSysDate(startDateString)
            if (now < endDate) {
                return false
            }

            return true
        })

        const flextimeTooltipItems = computed(() => {
            let items = []

            if (props.item.flextime_expected) {
                items.push({
                    name: $t("Expected"),
                    value: formatTimeDuration(props.item.flextime_expected)
                })
            }

            if (props.item.total) {
                items.push({
                    name: $t("Total"),
                    value: formatTimeDuration(props.item.total)
                })
            }

            if (props.item.flextime_balance) {
                items.push({
                    name: $t("Balance"),
                    value: formatFlextimeDuration(props.item.flextime_balance)
                })
            }

            return items
        })

        const navigateToVacations = (personId) => {
            const companyId = props.urlAdapter.getUrlParameter('account_id')[0]
            router.push({name: 'profile_vacations', params: {personId, companyId}})
        }

        const onAccountAvatarClick = (item) => {
            if (props.view === 'flextime') {
                navigateToVacations(item.group_id)
            } else {
                const current_grouping = String(props.grouping).split(";");
                const primary_grouping = current_grouping[0];
                if (primary_grouping === "client") {
                    navigate_report_default_route({
                        view: "detailed",
                        dates_list: props.urlAdapter.getUrlParameter("dates_list"),
                        client_id_list: [Number(item.group_id.split("_")[1])],
                        columns: default_task_columns,
                        groupBy: props.grouping,
                    });
                } else if (primary_grouping === "assignee") {
                    navigate_report_default_route({
                        view: "detailed",
                        dates_list: props.urlAdapter.getUrlParameter("dates_list"),
                        person_id_list: [Number(item.group_id)],
                        columns: default_task_columns,
                        groupBy: props.grouping,
                    });
                }
            }
        }

        const getFlextimePeriodShort = () => {
            let dates = props.urlAdapter.getUrlParameter('dates_list')
            if (dates && dates[2]) {
                if (dates[2].includes('sow_')) {
                    return $t('Week') + ' ' + props.item.flextime_week
                } else if (props.item.flextime_date_from && dates[2].includes('som_')) {
                    let date = parseSysDate(props.item.flextime_date_from)
                    return formatDateCustom(date, CustomFormats.numeric_month_with_short_year)
                }
            }

            return null
        }

        return {
            normalizedChild,
            format_time_from_seconds,
            onItemTitleClick,
            selectFlextimeDecisionOption,
            selectedFlextimeDecisionButtonIcon,
            selectedFlextimeDecisionText,
            isChangeFlextimeBalanceModalVisible,
            formatTimeDuration,
            loader,
            flextimeDecisionActionItems,
            isChangeFlextimeCommentModalVisible,
            isFlextimeHistoryModalVisible,
            isTdZeroPadding,
            selectedFlextimeDecisionIconColor,
            headerHasBorder,
            formatFlextimeDuration,
            formatDate,
            parseSysDate,
            updateBalance,
            updateComment,
            FlextimeModule,
            rightsModule,
            canEditCompanyOrIsEditablePeriod,
            flextimeTooltipItems,
            navigateToVacations,
            getFlextimePeriodShort,
            onAccountAvatarClick,
            deleteFlextime,
            companyId,
            formatByHeader: formatByHeader,
            formatPercent
        };
    }
};
</script>
